import React from 'react';

import './TooltipContentRoutes.theme.scss';

function TooltipContentRoutes() {
  return (
    <div className="rs-tooltip-big__content tooltip-content-routes">
      <div>Route topology</div>
      <ul className="info-tooltip-content-list">
        <li className="info-tooltip-content-list-item bullet-dot">
          The Route topology thumbnail provides a quick overview on the complexity of the found route.
        </li>
        <li className="info-tooltip-content-list-item bullet-dot">
          You may click the “preview” link or magnifier icon to view the route in detail.
        </li>
        <li className="info-tooltip-content-list-item bullet-dot">
          Clicking a node in the thumbnail will show the corresponding substance structure.
        </li>
      </ul>
    </div>
  );
}

export default TooltipContentRoutes;
